import { TFunction } from 'i18next'
import { z } from 'zod'

export const createReportSchema = (t: TFunction) =>
  z.object({
    title: z.string().min(1, {
      message: t('required'),
    }),
    reportFileId: z.string(),
  })
